import React from 'react'

export default function Footer() {
  return (
    <div
      style={{
        height: 120,
        backgroundColor: '#111',
        width: '100vw',
        minWidth: '100vw',
        maxWidth: '100vw',
      }}
    ></div>
  )
}
